import { useContext, useEffect, useState } from "react";
import { ConfigContext } from "../Config";
import ReactHeap from "reactjs-heap";
import { getStoredCookieConsent, subscribeToCookieConsent } from "@mealmanager/cookie-consent";

const HEAP_GLOBAL_KEY = "heap";

export default function HeapAnalytics() {
  const { state: config } = useContext(ConfigContext);
  const [canTrack, setCanTrack] = useState(() => getStoredCookieConsent() === "accepted");

  useEffect(() => {
    const unsubscribe = subscribeToCookieConsent((state) => {
      const allow = state === "accepted";
      setCanTrack(allow);
      if (!allow && typeof window !== "undefined") {
        console.log("[Heap] analytics disabled");
        const heap = (window as typeof window & { [HEAP_GLOBAL_KEY]?: { loaded?: boolean; resetIdentity?: () => void } })[
          HEAP_GLOBAL_KEY
        ];
        if (heap) {
          heap.loaded = false;
        }
        heap?.resetIdentity?.();
      } else if (allow && typeof window !== "undefined") {
        const heap = (window as typeof window & { [HEAP_GLOBAL_KEY]?: { loaded?: boolean } })[HEAP_GLOBAL_KEY];
        if (heap) {
          heap.loaded = true;
        }
      }
    });
    return unsubscribe;
  }, []);

  useEffect(() => {
    if (!config?.heapAnalytics || !canTrack) {
      return;
    }
    console.log("[Heap] analytics initialized");
    ReactHeap.initialize(config.heapAnalytics);
  }, [config?.heapAnalytics, canTrack]);

  return null;
}
